import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PainStories } from './components/PainStories';
import { Transformation } from './components/Transformation';
import { TheSystem } from './components/TheSystem';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Qualifier } from './components/Qualifier';
import { PremiumUpsell } from './components/PremiumUpsell';
import { Guarantee } from './components/Guarantee';
import { ClosingContrast } from './components/ClosingContrast';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-padel-dark text-gray-100 font-sans selection:bg-padel-lime selection:text-padel-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <PainStories data-id="element-4" />
      <Transformation data-id="element-5" />
      <TheSystem data-id="element-6" />
      <Bonuses data-id="element-7" />
      <ValueStack data-id="element-8" />
      <Qualifier data-id="element-9" />
      <PremiumUpsell data-id="element-10" />
      <Guarantee data-id="element-11" />
      <ClosingContrast data-id="element-12" />
      <Pricing data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}